module.exports = __webpack_public_path__ + "img/question_answer_filled.91680dbe.svg";